export default "__VITE_ASSET__D_b4i$WN__"